import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as fromAuth from 'src/app/store/auth';
import { actionNeedsAuthentication } from 'src/app/store/auth/auth.actions';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(childRoute, state);
  }

  canActivate(route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): Observable<boolean> {
    return this.store.pipe(
      select(fromAuth.selectAuthInfo),
      map(({ isAuthenticated }) => {
        if (!isAuthenticated) {
          this.store.dispatch(actionNeedsAuthentication({ returnUrl: routerState.url !== '/' ? routerState.url : undefined }));
          return false;
        }
        return true;
      }),
    );
  }

  constructor(private store: Store<fromAuth.AuthState>, private jwt: JwtHelperService) {}
}
